// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_PROJECT_TYPES,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getProjectTypes = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('project_types')
      .then(
        (response) => {
          dispatch(GET_PROJECT_TYPES, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/projectTypesActions.js